import { useEffect, useState } from "react";
import { _Entailment, _single, _TaxEntityConsecutive } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _TaxEntityConsecutivetwo, _UBLSoftwareDispatcher } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { EnvironmentTypeEditor } from "./SelectUBLEnviorement/SelectUBLEnviorement";
import { DispatchMethodTypeConstants } from "./DispatchMethodTypeConstants";
import { ConsecutiveByUBLSoftwareDispatcher } from "./ConsecutiveByUBLSoftwareDispatcher/ConsecutiveByUBLSoftwareDispatcher";


export const UBLSoftwareDispatcher = () => {
    const { instance, lista, setLista, bean, setBean, deleteItemVoid, update } = useDataBean(_UBLSoftwareDispatcher);
    const validate = useDataBean(_TaxEntityConsecutivetwo);
    const [modalrango, setModalrango] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalnum, setModalnum] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });


    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        instance.getUBLSoftwareDispatcherByAccount(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )
    }

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            IsEnabled: false,
        });
        setModal({ ...modal, "view": true, "name": "Crear Software de Facturación Electrónica" });
    }

    const deleteItem = () => {
        deleteItemVoid(bean.IDUBLSoftwareDispatcher).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )
    }
    const validateTaxEntityConsecutive = () => {
        validate.instance.validateTaxEntityConsecutive(bean.IDUBLSoftwareDispatcher).then(
            (resp: any) => {
                console.log(resp)
                getLista();
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const editaItem = () => {
        update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDUBLSoftwareDispatcher', visible: true },
        { title: 'Nombre', property: 'SoftwareName', visible: true },
        { title: 'Facturador', property: 'AccountName', visible: true },
        { title: 'Proveedor Tecnológico', property: 'AccountProviderName', visible: true },
        { title: 'Utilizar Facturador como Proveedor', property: 'UserCompanyAsProvider', visible: true },
        { title: 'Tipo de Ambiente', property: 'EnvironmentTypeName', visible: true },
        { title: 'Método de Envío', property: 'DispatchMethodTypeName', visible: true },
        { title: 'Clave Técnica', property: 'TechnicalKey', visible: true },
        { title: 'Pin del Software', property: 'SoftwarePin', visible: true },
        { title: 'ID de Pruebas', property: 'SoftwareTestID', visible: true },
        { title: 'ID del Software', property: 'SoftwareID', visible: true },
        { title: 'URL Servicio', property: 'UrlDispatcher', visible: true },
        { title: 'Código de Asignación', property: 'TaxEntityBillerCode', visible: true },
        { title: 'Clase UBLToXmlProvider', property: 'UBLToXmlProviderClass', visible: true },
        { title: 'Clase TaxEntityDispatcherClass', property: 'UBLTaxEntityDispatcherClass', visible: true },
        { title: 'Clase ToPdfProvider', property: 'UBLToPdfProviderClass', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: true },
        { title: 'Habilitado', property: 'IsEnabled', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Asociar Rango de Numeración', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { validateTaxEntityConsecutive() } },
            { titulo: 'Rangos de Numeración', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModalnum({ ...modalnum, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${bean.SoftwareName}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": "Eliminar Software de Facturación Electrónica" }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "SoftwareName", "IDAccount", "EnvironmentType", "UrlDispatcher"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <BasicPage titulo="Software de Facturación Electrónica">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                </div>

                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={validateData}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('SoftwareName') ? 'has-error' : ''}`}>Nombre</label>
                                <input type="text" name="SoftwareName" className="form-control" value={bean.SoftwareName} onChange={(e) => { setBean({ ...bean, "SoftwareName": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`}>Facturador</label>
                                <AccountEditor label=" " idAccount={bean.IDAccount} onChange={(e: any) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Proveedor Tecnológico</label>
                                <AccountEditor label=" " idAccount={bean.IDAccountProvider} onChange={(e: any) => { setBean({ ...bean, "IDAccountProvider": e.IDAccount }) }} />
                            </div>
                            <div className="col-md-6 mt-3">
                                <BasicSwitch estado={bean.UserCompanyAsProvider} label="Utilizar Facturador como Proveedor" eventChange={(e: any) => { setBean({ ...bean, "UserCompanyAsProvider": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <DispatchMethodTypeConstants idSelector={bean.DispatchMethodType} onChange={(e: any) => { setBean({ ...bean, "DispatchMethodType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código de Asignación</label>
                                <input type="text" name="TaxEntityBillerCode" className="form-control" value={bean.TaxEntityBillerCode} onChange={(e) => { setBean({ ...bean, "TaxEntityBillerCode": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Clase UBLTaxEntityDispatcher</label>
                                <input type="text" name="UBLTaxEntityDispatcherClass" className="form-control" value={bean.UBLTaxEntityDispatcherClass} onChange={(e) => { setBean({ ...bean, "UBLTaxEntityDispatcherClass": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Clase UBLToPdfProvider</label>
                                <input type="text" name="UBLToPdfProviderClass" className="form-control" value={bean.UBLToPdfProviderClass} onChange={(e) => { setBean({ ...bean, "UBLToPdfProviderClass": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Clase UBLToXmlProvider</label>
                                <input type="text" name="UBLToXmlProviderClass" className="form-control" value={bean.UBLToXmlProviderClass} onChange={(e) => { setBean({ ...bean, "UBLToXmlProviderClass": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('EnvironmentType') ? 'has-error' : ''}`}>Tipo de Ambiente</label>
                                <EnvironmentTypeEditor idSelector={bean.EnvironmentType} onChange={(e) => { setBean({ ...bean, "EnvironmentType": e }) }} label=" " />
                            </div>
                            <div className="col-md-6">
                                <label>Clave Técnica</label>
                                <input type="text" name="TechnicalKey" className="form-control" value={bean.TechnicalKey} onChange={(e) => { setBean({ ...bean, "TechnicalKey": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Pin del Software</label>
                                <input type="text" name="SoftwarePin" className="form-control" value={bean.SoftwarePin} onChange={(e) => { setBean({ ...bean, "SoftwarePin": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>ID del Software</label>
                                <input type="text" name="SoftwareID" className="form-control" value={bean.SoftwareID} onChange={(e) => { setBean({ ...bean, "SoftwareID": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>ID de Pruebas</label>
                                <input type="text" name="SoftwareTestID" className="form-control" value={bean.SoftwareTestID} onChange={(e) => { setBean({ ...bean, "SoftwareTestID": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('UrlDispatcher') ? 'has-error' : ''}`}>URL Servicio</label>
                                <input type="text" name="UrlDispatcher" className="form-control" value={bean.UrlDispatcher} onChange={(e) => { setBean({ ...bean, "UrlDispatcher": e.target.value }) }} />
                            </div>
                            <div className="col-md-6 mt-3">
                                <BasicSwitch estado={bean.IsEnabled} label="Habilitado" eventChange={(e: any) => { setBean({ ...bean, "IsEnabled": e }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalnum} updateModal={setModalnum}>
                        <div className="row">
                            <ConsecutiveByUBLSoftwareDispatcher idUBLSoftwareDispatcher={bean.IDUBLSoftwareDispatcher} />
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.SoftwareName}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}